export const colors = {
  success: "#22C55E",
  danger: "#e65061",
};
